<template>
  <div>
    <rest-list :payload="fetchEndpoint">
      <rest-list-column :title="$t('Engagement_Categories_Title')" prop="title">
        <template #default="scope">
          <div>
            <router-link
              :to="route(scope.row)"
              data-qa="engagement-category-link"
            >
              {{ scope.rowValue(scope) }}
            </router-link>
          </div>
        </template>
      </rest-list-column>
      <rest-list-column-actions>
        <template slot-scope="scope">
          <rest-list-action
            v-if="$can('updateProjectItem')"
            :route="rowUpdateRoute(scope.row)"
            icon="el-icon-edit-outline"
            :title="$t('RestList_Action_Update')"
            data-qa="edit-action-button"
          />
          <rest-list-action-view v-else :route="rowViewRoute(scope.row)" />
          <rest-list-action-delete
            v-if="$can('deleteProjectItem')"
            :endpoint="rowDeleteRoute(scope.row)"
            :name="scope.row.title"
            :delete-message="() => getDeleteMessage(scope.row.id)"
            :html-warning-msg="true"
          />
        </template>
      </rest-list-column-actions>
    </rest-list>
  </div>
</template>

<script>
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'
import RestList from '@/common/components/rest/RestList'
import RestListAction from '@/common/components/rest/RestListAction.vue'
import RestListActionView from '@/common/components/rest/RestListActionView.vue'
import _ from 'lodash'
import RestListColumn from '@/common/components/rest/RestListColumn.vue'
import memoize from 'memoizee'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'EngagementCategoriesTab',
  components: {
    RestListColumn,
    RestListActionView,
    RestListAction,
    RestList,
    RestListColumnActions,
    RestListActionDelete
  },

  data() {
    return {}
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'categories',
        params: {}
      })
    }
  },

  methods: {
    async getDeleteMessage(categoryId) {
      let msg = this.$t('EngageCategories_DeleteTitle')
      const campaigns = await this.fetchCampaignsWithCategoryId(categoryId)
      const campaignTitles = campaigns
        .map(campaign => campaign.title)
        .join('<br>')

      if (campaignTitles.length) {
        msg += this.$t('EngageCategories_DeleteDesc', {
          titles: campaignTitles
        })
      }

      return msg
    },
    fetchCampaignsWithCategoryId: memoize(
      categoryId =>
        RestApi(
          projectEndpoint({
            method: 'get',
            url: `campaigns`,
            params: {
              category_id: categoryId
            }
          })
        ).then(({ data }) => data),
      { promise: true, maxAge: 5000 }
    ),
    rowUpdateRoute(row) {
      return projectRoute({
        name: 'EngagementCategoryUpdate',
        query: { id: row.id }
      })
    },
    rowDeleteRoute(row) {
      return projectEndpoint({
        method: 'delete',
        url: `categories/${row.id}`
      })
    },
    rowViewRoute(row) {
      return projectRoute({
        name: 'EngagementCategoryView',
        query: { id: row.id }
      })
    },
    rowClickRoute(row) {
      return projectRoute({
        name: 'EngagementCategoryUpdate',
        query: {
          id: row.id
        }
      })
    },
    rowValue(scope) {
      return this.formatter(_.get(scope.row, this.prop), scope.row)
    },
    route(row) {
      if (this.$can('updateProjectItem')) {
        return this.rowUpdateRoute(row)
      }
      return this.rowViewRoute(row)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaigns/components/EngagementCategoriesTab.vue